import { render, staticRenderFns } from "./Eventos-Listagem.vue?vue&type=template&id=4009227e&scoped=true&"
import script from "./Eventos-Listagem.vue?vue&type=script&lang=js&"
export * from "./Eventos-Listagem.vue?vue&type=script&lang=js&"
import style0 from "./Eventos-Listagem.vue?vue&type=style&index=0&id=4009227e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4009227e",
  null
  
)

component.options.__file = "Eventos-Listagem.vue"
export default component.exports